import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService, DialogService } from 'src/app/services';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';
import { LanguageService } from '../../language/language.service';

@Component({
  selector: 'esc-display-error',
  templateUrl: './display-error.component.html',
  styleUrls: ['./display-error.component.scss']
})
export class DisplayErrorComponent implements OnInit {

  constructor(
    public authService: AuthService,
    private dialogService: DialogService,
    public languageService: LanguageService,
    public dialogRef: MatDialogRef<DisplayErrorComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  displayedColumns: string[] = ['tagName', 'rowData', 'errorMessage'];  
  
  excelHeaderNames = [
    { name: "Tag Name", key: "tagName" },
    { name: "Row Data", key: "rowData" },
    { name: "Error Message", key: "errorMessage" },
  ];

  public listData = []; 

  public loading = {
    init: false,
    more: false,
    export: false,
    import: false
  };

  public error = {
    init: false
  }

  ngOnInit() {
    this.listData = this.listData.concat(this.data);
  }

  download() {
    this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_EXPORTING_FILE", {}));
    this.loading.export = true;
    let result = _.map(this.listData, (row) => {
      let newRow = {};
      _.forEach(this.excelHeaderNames, (header) => {
        newRow[header.name] = row[header.key];
      })
      return newRow;
    });
    let now = new Date(Date.now());
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(result);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws);
    this.loading.export = false;
    XLSX.writeFile(wb, "Upload XML Errors - " + now + '.xlsx');
  }

}
